(() => {
  const setup = () => {
    const suffix = new URLSearchParams(window.location.search).get('view') || '';
    const routeMap = {'lb-how-it-works':'process','lb-book':'book','lb-about':'about','lb-faq':'faq','lb-contact':'contact'};
    const path = window.location.pathname;
    let current = routeMap[suffix] || 'home';
    if (!suffix && path.includes('/products/')) current = 'book';
    if (!suffix && path.includes('/pages/')) current = {'how-it-works':'process','about':'about','faq':'faq','contact':'contact'}[path.split('/').filter(Boolean).pop()] || '';
    document.querySelectorAll('[data-lb-nav]').forEach(link => {
      if (link.dataset.lbNav === current) link.setAttribute('aria-current','page');
      else link.removeAttribute('aria-current');
    });
    const menu = document.querySelector('.lb-mobile-menu');
    if (menu && !menu.dataset.initialized) {
      menu.dataset.initialized = 'true';
      menu.addEventListener('keydown', event => {
        if (event.key === 'Escape') { menu.open = false; menu.querySelector('summary').focus(); }
      });
      menu.querySelectorAll('a').forEach(link => link.addEventListener('click', () => { menu.open = false; }));
      document.addEventListener('click', event => { if (menu.open && !menu.contains(event.target)) menu.open = false; });
    }
    revealHash();
  };
  const revealHash = () => {
    if (!window.location.hash) return;
    let id;
    try { id = decodeURIComponent(window.location.hash.slice(1)); } catch { return; }
    const target = document.getElementById(id);
    if (!target) return;
    const disclosure = target.matches('details') ? target : target.closest('details');
    if (disclosure) disclosure.open = true;
  };
  document.addEventListener('DOMContentLoaded', setup);
  document.addEventListener('shopify:section:load', setup);
  window.addEventListener('hashchange', revealHash);
})();
